import type { Response } from "./scorecards";

export const scorecardSummaryRoute = "/scorecard/responses/:id/summary";

export function scorecardSummaryPath(id: number) {
  return `/scorecard/responses/${id}/summary`;
}

export function parseResponseId(value: string | undefined): number | null {
  if (!value || !/^[1-9]\d*$/.test(value)) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) ? id : null;
}

export function findPreviousResponse(responses: Response[], current: Response) {
  const completedAt = new Date(current.completed_at ?? current.updated_at).getTime();
  return responses
    .filter((response) => {
      const date = new Date(response.completed_at ?? response.updated_at).getTime();
      return response.status === "completed"
        && response.user === current.user
        && response.organization === current.organization
        && response.id !== current.id
        && date < completedAt;
    })
    .sort((a, b) =>
      new Date(b.completed_at ?? b.updated_at).getTime()
      - new Date(a.completed_at ?? a.updated_at).getTime(),
    )[0] ?? null;
}
